module.exports = "<mdl-progress class=\"loading-bar\" [indeterminate]=\"true\" *ngIf=\"canShowLoadingBar | async\"></mdl-progress>"